var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31208 7.75245L7.69208 7.75245L6.00208 9.44245L4.31208 7.75245ZM5.64708 10.1475C5.84208 10.3425 6.15708 10.3425 6.35208 10.1475L8.64708 7.85245C8.96208 7.54245 8.74208 7.00245 8.29708 7.00245L3.70708 7.00245C3.26208 7.00245 3.03708 7.54245 3.35208 7.85745L5.64708 10.1475ZM3.70708 5.00245L8.29208 5.00245C8.73708 5.00245 8.96208 4.46245 8.64708 4.14745L6.35208 1.85245C6.15708 1.65745 5.84208 1.65745 5.64708 1.85245L3.35208 4.14745C3.04208 4.46245 3.26208 5.00245 3.70708 5.00245Z",
    fill: "#6A6F7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/Ascending.adefa4d77f318f06e4320e9fc2a4dda7.svg";
export { ForwardRef as ReactComponent };